import React, { useEffect, useState } from 'react'
import { useGetIdentity, useInvalidate, useList, useMany, useNavigation } from '@pankod/refine-core'
import {
  Tag,
  Progress,
  Breadcrumb,
  Tooltip,
  Icons,
  Button,
  PageHeader,
  Typography,
  Skeleton,
  Descriptions,
  useModalForm,
  Divider,
  Table,
  Row,
  Col,
  ErrorComponent,
} from '@pankod/refine-antd'
import { IGrade, IParentChildReference, IQuestion, IUser, IWorkRequest } from 'interfaces'
import { EditWorkRequest } from './edit'
import Permissions from 'permissions'
import { getTeacherLevelByStrand } from 'gql/query'
import { Questions } from './showQuestions'
// import { Questions } from './showQuestions'

import { CompletionStatus, getWorkRequestStatusCount } from 'helpers'
import dayjs from 'dayjs'
import { useUserContext } from 'context/user'
import { CheckUserAccess } from 'components/accessability'
import { AllQuestionListPage } from 'pages/all_questions/list'
import ReferenceDataTable from './referenceDataTable'
const { Text } = Typography

type WorkRequestPageHeaderProps = {
  record: any
  metaData: any
  updatePercentage: any
}
type ReviewerApprover = {
  reviewer_id: string
  reviewer_name: string
  approvers: object[]
}
type Permission = {
  granted?: boolean
}
export const WorkRequestPageHeader: React.FC<WorkRequestPageHeaderProps> = ({ record, metaData, updatePercentage }) => {
  const { data: user } = useGetIdentity()
  const invalidate = useInvalidate()
  const [reviewedCount, setReviewerCount] = useState(0)

  const [approvedCount, setApprovedCount] = useState(0)
  const [totalReviewCont, setTotalReviewerCount] = useState(0)
  const [totalApproveCount, setTotalApproveCount] = useState(0)
  const [overallCount, setOverallCount] = useState(0)
  const [rejectedCount, setRejectedCount] = useState(0)
  const [rejectedApproveCount, setRejectedApproveCount] = useState(0)
  const [rejectedApproveCountCreator, setRejectedApproveCountCreator] = useState(0)
  const [deletedCount, setDeletedCount] = useState(0)
  const [variantListIds, setVariantListIds] = useState<string[]>([])
  const [approverList, setApproverList] = useState([{ reviewer: '', approver: [], reviewer_id: '' }])
  // const [reviewerList, setReviewerList] = useState([] as any[])
  const [variantList, setVariantList] = useState<object[]>([])
  const { userRole, qapproverList, qreviewerList } = useUserContext()
  const [editPermission, setEditPermission] = useState<Permission>({})

  const [loadAppList, setLoading] = useState(true)
  const [teacherLevel, setTeacherLevel] = useState('')
  const { list } = useNavigation()

  useEffect(() => {
    invalidate({
      resource: 'work_requests',
      invalidates: ['detail'],
      id: record?.id,
    })
  }, [record])
  useEffect(() => {
    if (record?.strand_id !== null && record?.strand_id !== undefined && record?.strand_id !== '') {
      getTeacherLevelByStrand(record?.strand_id).then((resp: any) => {
        setTeacherLevel(resp?.strands?.[0]?.teacher_level?.name)
      })
    }
  }, [record])

  useEffect(() => {
    if (userRole !== undefined) {
      setEditPermission(Permissions.can(userRole).updateAny('work_requests'))
    }
    // if (userRole === 'qcreator' || userRole === 'variantcreator') {
    //   {
    //     if (record?.creator_id !== user?.id) list('work_requests')
    //   }
    // } else if (userRole === 'qreviewer') {
    //   if (!record?.reviewer_ids.includes(user?.id)) {
    //     list('work_requests')
    //   }
    // } else if (userRole === 'qapprover') {
    //   if (!record?.all_approver_ids.includes(user?.id)) {
    //     list('work_requests')
    //   }
    // } else if (userRole === 'subjectincharge') {
    //   if (record?.created_by !== user?.id) list('work_requests')
    // }
  }, [userRole])
  useEffect(() => {
    if (record?.request_type === 'V') {
      let arr: string[] = []

      record?.variant_options?.length > 0 &&
        record?.variant_options?.map((item: any) => {
          if (item?.question_id !== null) arr.push(item?.question_id)
        })
      setVariantListIds(arr)
    }
  }, [record])

  const { data: questionQueryResult, isLoading } = useMany<IQuestion>({
    resource: 'questions',
    ids: variantListIds,
    metaData: {
      fields: ['id', 'title', 'question_id'],
    },
  })
  const getApproverReviewerList = async () => {
    let arr: any[] = []
    if (record?.workRequestApprovers?.length > 0) {
    } else if (record?.workRequestReviewers?.length > 0) {
    }

    arr = arr.filter(
      (elem: any, index: any, self: any) =>
        self.findIndex((t: any) => {
          return t.reviewer_id === elem.reviewer_id && t.reviewer_id !== ''
        }) === index
    )

    return arr
  }
  useEffect(() => {
    getApproverReviewerList().then((resp: any) => {
      setApproverList(resp)
      setLoading(false)
    })
  }, [record?.workRequestApprovers])

  useEffect(() => {
    let arr: object[] = []
    questionQueryResult?.data?.forEach(element => {
      record?.variant_options?.forEach((variant: any) => {
        if (variant?.question_id === element?.id) {
          arr.push({
            title: element?.title,
            question_id: element?.question_id,
            id: element?.id,
            count: variant?.variant_count,
          })
        }
      })
    })
    setVariantList(arr)
  }, [questionQueryResult])

  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
    close: editClose,
  } = useModalForm({
    resource: 'work_requests',
    action: 'edit',
    warnWhenUnsavedChanges: false,
    metaData,
    redirect: false,
    onMutationSuccess: updatePercentage,
  })

  useEffect(() => {
    const {
      reviewed_count,
      total_deleted,
      approved_count,
      total_to_review,
      total_to_approve,
      rejected_count,
      overall_count,
      rejected_approve_count,
      rejected_approve_count_creator,
    } = getWorkRequestStatusCount(record)
    setTotalReviewerCount(total_to_review)
    setTotalApproveCount(total_to_approve)
    setReviewerCount(reviewed_count)
    setApprovedCount(approved_count)
    setOverallCount(overall_count)
    setRejectedCount(rejected_count)
    setRejectedApproveCount(rejected_approve_count)
    setRejectedApproveCountCreator(rejected_approve_count_creator)
    setDeletedCount(total_deleted)
    // CompletionStatus(record)
    updatePercentage()
  }, [record])

  useEffect(() => {
    renderApproverReviewerUsers()
  }, [record])
  const renderApproverReviewerUsers = () => {
    let arr_reviewer: object[] = []
    let arr_approver: ReviewerApprover[] = []
    {
      console.log('workRequestReviewers', record?.workRequestReviewers)
    }
    record?.workRequestReviewers?.length > 0 &&
      record?.workRequestReviewers?.map((item: any) => {
        if (record?.workRequestApprovers?.length > 0) {
          record?.workRequestApprovers?.map((approv: any) => {
            if (approv?.reviewer_id === item?.user_id) {
              var found = arr_approver.findIndex(function (doundIndex: any) {
                return doundIndex?.reviewer_id === approv.reviewer_id
              })
              if (found > -1) {
                arr_approver[found]?.approvers?.push(approv?.userByApprover?.displayName)
                // app_arr.push(approv?.userByApprover?.displayName)
                // arr_approver approvers[found]?.push(approv?.userByApprover?.displayName)
              } else {
                let app_arr: object[] = []
                app_arr.push(approv?.userByApprover?.displayName)
                arr_approver.push({
                  reviewer_id: approv?.reviewer_id,
                  reviewer_name: approv?.userByReviewerId[0]?.displayName,
                  approvers: app_arr,
                })
              }
            } else {
              arr_approver.push({
                reviewer_id: item?.user_id,
                reviewer_name: item?.userByReviewerId?.displayName,
                approvers: [],
              })
            }
          })
        } else {
          arr_approver.push({
            reviewer_id: item?.user_id,
            reviewer_name: item?.userByReviewerId?.displayName,
            approvers: [],
          })
        }
      })
    arr_approver = arr_approver.filter(
      (elem: any, index: any, self: any) =>
        self.findIndex((t: any) => {
          return t.reviewer_id === elem.reviewer_id
        }) === index
    )

    return (
      <>
        {arr_approver?.length > 0 ? (
          <>
            <Col xs={24} lg={16}>
              <div>
                <b>{`Reviewers    &    Approvers`}</b>
                {arr_approver?.map((item: any, i: any) => (
                  <div style={{ display: 'flex', padding: '2px 0' }}>
                    {userRole === 'qcreator' || userRole === 'qapprover' ? (
                      <div style={{ display: 'block', padding: '2px 0' }}> {item?.reviewer_name !== '' ? `R${i + 1}` : ''}</div>
                    ) : (
                      <div style={{ display: 'block', padding: '2px 0' }}> {`${item?.reviewer_name}  :   `}</div>
                    )}
                    {item?.approvers?.length > 0 &&
                      item?.approvers?.map((approv: any, index: any) => (
                        <div style={{ display: 'block', padding: '2px 0' }}>
                          {userRole === 'qcreator' || userRole === 'qreviewer' ? (
                            <Text keyboard>{approv !== '' ? `A${index + 1}` : null}</Text>
                          ) : (
                            <Text keyboard>{approv}</Text>
                          )}
                        </div>
                      ))}
                  </div>
                ))}
              </div>
            </Col>
          </>
        ) : arr_reviewer?.length > 0 ? (
          <>
            <Col xs={24} lg={16}>
              <div>
                <b>{`Reviewers`}</b>
                {arr_reviewer?.map((item: any, index: any) =>
                  userRole === 'qcreator' || userRole === 'qapprover' ? (
                    <div style={{ display: 'block', padding: '2px 0' }}> {item !== '' ? `R${index + 1}` : null}</div>
                  ) : (
                    <div style={{ display: 'block', padding: '2px 0' }}> {item}</div>
                  )
                )}
              </div>
            </Col>
          </>
        ) : (
          <>
            <Col xs={24} lg={8}>
              <div>
                <b>{`Reviewers    &    Approvers`}</b>
              </div>
            </Col>
          </>
        )}
      </>
    )
  }
  return (
    <>
      <PageHeader
        className="site-page-header-responsive"
        ghost={false}
        title={`  #${record?.request_id ?? ''} - ${record?.name}`}
        subTitle={record?.request_type}
        extra={[
          <Button key="close" onClick={() => window.history.back()} icon={<Icons.LeftOutlined />}>
            Back
          </Button>,

          <Button
            style={{
              display: editPermission !== undefined && editPermission?.granted ? 'block' : 'none',
            }}
            disabled={
              record?.status === 'Closed' ||
              (record?.status === 'Draft' &&
                record?.subject_incharge_id !== '' &&
                record?.subject_incharge_id !== undefined &&
                record?.created_by !== record?.subject_incharge_id) ||
              (!!record?.subject_incharge_id && record?.subject_incharge_id !== user?.id)
            }
            key="edit"
            icon={<Icons.EditOutlined />}
            type="primary"
            onClick={() => {
              editShow(record.id)
            }}
          >
            Edit
          </Button>,
        ]}
      >
        <Descriptions size="small" column={3}>
          <Descriptions.Item label="">{<Tag color="blue">{record?.status}</Tag>}</Descriptions.Item>
        </Descriptions>
        <Descriptions size="small" column={2}>
          <Descriptions.Item label="Request Type">{`${
            record?.request_type === 'Q' ? 'Question Creation' : record?.request_type === 'PC' ? 'Parent Child Question' : 'Variant Creation'
          }`}</Descriptions.Item>
          <Descriptions.Item label="Grade">
            {record?.workRequestGrades?.length > 0 &&
              record?.workRequestGrades?.map((item: any) => <Tag key={item?.grade_id}>{item?.grade?.name}</Tag>)}
          </Descriptions.Item>
          {/* {record?.grade_ids?.length > 0 ? <Descriptions.Item label="Grade">{renderGrades(record?.grade_ids)}</Descriptions.Item> : null} */}
          <Descriptions.Item label="Subject">{record?.subject?.name}</Descriptions.Item>
          {/* <Descriptions.Item label=" Report Theme">{record?.report_theme?.name}</Descriptions.Item> */}
          <Descriptions.Item label="Theme">{record?.theme?.name}</Descriptions.Item>
          <Descriptions.Item label="Sub Theme">{record?.sub_theme?.name}</Descriptions.Item>
          <Descriptions.Item label="Topic">{record?.topic?.name}</Descriptions.Item>
          {/* <Descriptions.Item label="Question Type">{record?.question_type?.name}</Descriptions.Item> */}
          <Descriptions.Item label="Due Date">{record?.due_date !== null ? dayjs(record?.due_date).format('DD/MM/YYYY') : ''}</Descriptions.Item>
          {record?.request_type === 'Q' && <Descriptions.Item label="No of Questions">{record?.count}</Descriptions.Item>}
        </Descriptions>
        <Divider style={{ margin: ' 0' }} />
        <b>Tags:</b>
        <Descriptions size="small" column={3}>
          <Descriptions.Item label="Teacher Level">
            {record?.strand_id !== null && record?.strand_id !== undefined && record?.strand_id !== '' ? teacherLevel : ''}
          </Descriptions.Item>
          <Descriptions.Item label="Competencies">{record?.competencies?.name}</Descriptions.Item>
          <Descriptions.Item label="Taxonomy">{record?.taxonomy?.name}</Descriptions.Item>
          <Descriptions.Item label="Bloom Level">{record?.bloom_level?.name}</Descriptions.Item>
          <Descriptions.Item label="Difficulty">{record?.difficulty_levels?.name}</Descriptions.Item>
          <Descriptions.Item label="Standard">{record?.strands?.name}</Descriptions.Item>

          {/* <Descriptions.Item label="Centa Standard">{record?.centa_standard?.name}</Descriptions.Item> */}
        </Descriptions>
        <Divider style={{ margin: ' 12px 0' }} />
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={8}>
            <div>
              <b>Creator</b>

              <div>{record?.userByCreatorId?.displayName}</div>
            </div>
          </Col>

          {renderApproverReviewerUsers()}
        </Row>

        {/* <Descriptions.Item label="Reviewer">{record?.userByReviewerId?.displayName}</Descriptions.Item> */}
        {/* <Descriptions.Item label="Approver">{record?.userByApproverId?.displayName}</Descriptions.Item> */}
        <Divider style={{ margin: '12px 0' }} />
        {/* Variant Details *****************/}
        {record?.request_type === 'V' ? (
          <>
            <b>Variant Details:</b>
            <div>
              {variantList?.length > 0 && (
                <Table
                  style={{ display: 'inline-block', minWidth: '300px' }}
                  // showHeader={false}
                  size="small"
                  bordered
                  dataSource={variantList}
                  pagination={false}
                  columns={[
                    {
                      title: 'Id',
                      dataIndex: 'question_id',
                      render: text => <>{`${text}`}</>,
                    },
                    {
                      title: 'Question',
                      dataIndex: 'title',
                      render: text => <>{` ${text}`}</>,
                    },
                    {
                      title: 'Count',
                      dataIndex: 'count',
                      render: text => <>{`${text}`}</>,
                    },
                  ]}
                />
              )}
            </div>
            <Divider style={{ margin: ' 0' }} />
          </>
        ) : null}
        {/* ********************************* */}
        <h3>
          {record?.count} {record?.question_type?.name} Questions
        </h3>
        <Descriptions size="small" column={4} layout="vertical">
          <Descriptions.Item label={`Over all  - ${approvedCount}/${record?.count}`}>
            <Tooltip title={`Reviewer - ${reviewedCount} done / ${record?.count - reviewedCount} to do`}>
              <Progress width={50} percent={parseFloat(overallCount.toFixed(1)) || 0} type="circle" />
            </Tooltip>
          </Descriptions.Item>
          <Descriptions.Item
            label={`Creator ${record?.questions?.length - rejectedCount - deletedCount - rejectedApproveCountCreator}/${record?.count}`}
          >
            <Tooltip
              title={`Creator - ${record?.questions?.length - rejectedCount - deletedCount - rejectedApproveCountCreator} done / ${
                record?.count - (record?.questions?.length - rejectedCount - deletedCount - rejectedApproveCountCreator)
              } to do or rejected`}
            >
              <Progress
                width={50}
                status={
                  ((record?.questions?.length - rejectedCount - deletedCount - rejectedApproveCountCreator) / record?.count) * 100 === 100
                    ? 'success'
                    : 'normal'
                }
                percent={
                  parseFloat(
                    (((record?.questions?.length - rejectedCount - deletedCount - rejectedApproveCountCreator) / record?.count) * 100).toFixed()
                  ) || 0
                }
                type="circle"
              />
            </Tooltip>
          </Descriptions.Item>
          {/* <Descriptions.Item label={`Rejected ${rejectedCount}/${record?.count}`}>
            <Tooltip title={`Creator - ${record?.questions.length - rejectedCount} done / ${record?.count - (record?.questions.length-rejectedCount)} to do`}>
              <Progress
                width={50}
                status={(record?.questions.length / record?.count) * 100 === 100 ? 'success' : 'normal'}
                percent={parseFloat(((record?.questions.length / record?.count) * 100).toFixed(1))}
                type="circle"
              />
            </Tooltip>
          </Descriptions.Item> */}
          <Descriptions.Item label={`Reviewer ${reviewedCount}/${totalReviewCont}`}>
            <Tooltip title={`Reviewer - ${reviewedCount} done / ${totalReviewCont - reviewedCount} to do or rejected`}>
              <Progress
                width={50}
                status={(reviewedCount / record?.count) * 100 === 100 ? 'success' : 'normal'}
                percent={parseFloat((((reviewedCount - rejectedApproveCount) / record?.count) * 100).toFixed()) || 0}
                type="circle"
              />
            </Tooltip>
          </Descriptions.Item>
          <Descriptions.Item label={`Approver ${approvedCount}/${totalApproveCount}`}>
            <Tooltip title={`Approver - ${approvedCount} done / ${totalApproveCount - approvedCount} to do or rejected`}>
              <Progress
                width={50}
                status={(approvedCount / record?.count) * 100 === 100 ? 'success' : 'normal'}
                percent={parseFloat(((approvedCount / record?.count) * 100).toFixed()) || 0}
                type="circle"
              />
            </Tooltip>
          </Descriptions.Item>
        </Descriptions>

        {record?.request_type === 'PC' && (
          <>
            <ReferenceDataTable record={record} userId={user?.id} userRole={userRole} />
          </>
        )}

        <div>
          <b>Notes:</b>
          <br />
          {record?.description}
        </div>

        {!record && <Skeleton paragraph={{ rows: 1 }} />}
        {(record?.request_type === 'V' && userRole === 'qcreator') || (record?.request_type === 'Q' && userRole === 'variantcreator') ? (
          <></>
        ) : // <Questions request={record} updatePercentage={updatePercentage} />
        record?.id ? (
          <AllQuestionListPage
            workRequestDetails={{ workrequestId: record?.id || '' }}
            request={record}
            qreviewerList={qreviewerList}
            qapproverList={qapproverList}
            updatePercentage={updatePercentage}
          />
        ) : (
          <Skeleton />
        )}
      </PageHeader>

      {/* <Questions record={record} updatePercentage={updatePercentage} /> */}
      {/* <EditWorkRequest close={editClose} refreshData={refreshData} modalProps={editModalProps} formProps={editFormProps} record={record} /> */}
      <EditWorkRequest
        close={editClose}
        refreshData={{}}
        modalProps={editModalProps}
        formProps={editFormProps}
        record={record}
        updatePercentage={updatePercentage}
      />
    </>
  )
}
